/**
 * The TM PLUS wordmark — the artwork the site serves as /img/tmplus.svg,
 * inlined for the same reason TodaMateriaLogo is: Lume renders in a shadow root
 * with no PHP-side Utils::getStaticUrl() to build a CDN path from.
 *
 * MONOCHROME, unlike the file on disk. That one is yellow #FEDA00 with a gold
 * #C19D46 back-plate on the plus; here every path is currentColor and the
 * back-plate keeps its two-tone through opacity alone. One component then
 * covers both grounds the offer appears on — brand yellow over indigo, and the
 * --plus-* indigo over a light card — with no second file to keep in sync.
 *
 * Give it a height and leave the width alone: the viewBox carries the 345:40
 * ratio, so `h-3 w-auto` resolves. An inline SVG with a height and NO viewBox
 * has no intrinsic ratio and stretches to its container's full width instead.
 */
export default function TmPlusWordmark({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      fill="none"
      role="img"
      viewBox="0 0 345 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Toda Matéria+</title>
      <path
        d="M333.8 39.0199V27.9399H344.88V20.9199H326.78V39.0199H333.8Z"
        fill="currentColor"
        opacity="0.68"
      />
      <path
        d="M326.78 9.82031V20.9203H315.68V27.9203H333.78V9.82031H326.78Z"
        fill="currentColor"
      />
      <path
        d="M51.56 24.48C51.56 15.7 44.4 8.84 36 8.86C27.46 8.86 20.36 15.76 20.38 24.56C20.38 26.18 20.64 27.72 21.12 29.18C21 32.44 18.88 34.46 15.56 34.46C12.3 34.46 10.28 32.32 10.26 28.88V15.36H20V9.84H10.22V0H4.06002V9.82H0.52002V15.34H4.10002V28.86C4.14002 35.68 8.58002 39.96 15.58 39.96C19.86 39.96 23.08 38.12 24.66 35.04C27.54 38.06 31.62 39.96 36.08 39.96C44.5 39.96 51.6 32.98 51.58 24.46L51.56 24.48ZM26.7 24.52C26.7 19.12 30.92 15.06 36.14 15.04C41.18 15.04 45.42 19.08 45.44 24.48C45.44 29.64 41.22 33.76 36.18 33.78C30.96 33.78 26.72 29.68 26.7 24.52Z"
        fill="currentColor"
      />
      <path
        d="M83.8201 0H77.6801L77.7001 13C75.1001 10.4 71.6001 8.82 67.8001 8.84C59.7401 8.84 53.0401 15.74 53.0601 24.54C53.0601 33.08 59.8201 40 67.8601 39.98C71.6601 39.98 75.1401 38.36 77.7401 35.76V38.9H83.8801L83.8201 0ZM59.1601 24.52C59.1601 19.12 63.3801 15.06 68.6001 15.04C73.0601 15.04 76.9001 18.2 77.7201 22.68C77.8201 23.26 77.8801 23.86 77.8801 24.48C77.8801 25.06 77.8201 25.64 77.7201 26.2C76.9201 30.52 73.0801 33.76 68.6201 33.78C63.4001 33.78 59.1601 29.68 59.1401 24.52H59.1601Z"
        fill="currentColor"
      />
      <path
        d="M104.6 12.3198L103.92 9.83984H89.34V15.3598H99.04L99.82 18.1998C98.82 17.8998 97.78 17.7398 96.72 17.7398C90.72 17.7398 85.66 22.6998 85.68 28.9398C85.68 35.0798 90.76 39.9998 96.76 39.9798C99.9 39.9798 102.78 38.5998 104.8 36.3998L105.5 38.9798H111.88L104.6 12.3198ZM97.52 23.3798C99.2 23.3798 100.78 24.1798 101.8 25.4598C102.54 26.3998 103.02 27.5998 103.02 28.9398C103.02 29.1998 103.02 29.4598 102.96 29.6998C102.58 32.3398 100.18 34.2798 97.54 34.2798C94.24 34.2798 91.74 31.9598 91.74 28.9598C91.74 25.7598 94.2 23.3798 97.52 23.3798Z"
        fill="currentColor"
      />
      <path
        d="M203.82 0H197.68V9.82H192.9V15.34H197.68V28.86C197.68 35.5 202.28 39 209.04 39H210.52V33.48H209.04C206.16 33.48 203.82 32.06 203.82 28.88V15.36H210.52V9.84H203.82V0Z"
        fill="currentColor"
      />
      <path
        d="M235.74 1H221.18V5.92H235.74V1Z"
        fill="currentColor"
      />
      <path
        d="M237.26 24.5204L242.9 24.4604C242.9 15.6804 235.84 8.86035 227.3 8.86035C218.76 8.86035 211.7 15.6804 211.7 24.4604C211.7 33.2404 218.76 40.0004 227.3 40.0004C233.44 40.0004 238.84 36.3804 241.42 31.2204L235.78 28.5804C234.3 31.6604 231.06 33.8604 227.3 33.8604C222.08 33.8604 217.78 29.6804 217.78 24.5204H237.24H237.26ZM219.14 19.6204C220.8 16.8404 223.86 15.0204 227.3 15.0204C230.74 15.0204 233.74 16.8404 235.4 19.6204H219.12H219.14Z"
        fill="currentColor"
      />
      <path
        d="M251.3 9.90039H245.52V39.0004H251.66V15.4204H261.5V9.90039H251.66H251.3Z"
        fill="currentColor"
      />
      <path
        d="M269.22 0.0800781C267.38 0.0800781 265.9 1.56008 265.9 3.40008C265.9 5.36008 267.38 6.84008 269.22 6.84008C271.06 6.84008 272.66 5.36008 272.66 3.40008C272.66 1.56008 271 0.0800781 269.22 0.0800781Z"
        fill="currentColor"
      />
      <path
        d="M263.56 15.4204H266.52V39.0004H272.66V9.90039H263.56V15.4204Z"
        fill="currentColor"
      />
      <path
        d="M156.38 8.83984C152.74 8.83984 149.56 10.8998 147.5 13.4398C145.86 10.4398 142.88 8.83984 139.32 8.83984C135.38 8.83984 132.88 10.7598 131.4 13.0598V9.83984H126.48V38.9598H132.54V20.7998C132.54 17.1398 134.98 14.5998 138.28 14.5998C142.4 14.5998 144.24 17.3798 144.18 20.7998V38.9598H150.08V20.7998C150.02 17.4998 152.7 14.5998 155.98 14.5998C159.26 14.5998 161.72 16.5598 161.72 20.7998V38.9598H167.72V20.5798C167.72 13.4598 162.88 8.83984 156.4 8.83984H156.38Z"
        fill="currentColor"
      />
      <path
        d="M188.18 9.82031H173.6V15.3403H183.3L184.08 18.1803C183.08 17.8803 182.04 17.7203 180.98 17.7203C174.98 17.7203 169.92 22.6803 169.94 28.9203C169.94 35.0603 175.02 39.9803 181.02 39.9603C184.16 39.9603 187.04 38.5803 189.06 36.3803L189.76 38.9603H196.14L188.86 12.3003L188.18 9.82031ZM187.22 29.7003C186.84 32.3403 184.44 34.2803 181.8 34.2803C178.5 34.2803 176 31.9603 176 28.9603C176 25.7603 178.46 23.3803 181.78 23.3803C183.46 23.3803 185.04 24.1803 186.06 25.4603C186.8 26.4003 187.28 27.6003 187.28 28.9403C187.28 29.2003 187.28 29.4603 187.22 29.7003Z"
        fill="currentColor"
      />
      <path
        d="M293.82 12.3198L293.14 9.83984H278.56V15.3598H288.26L289.04 18.1998C288.04 17.8998 287 17.7398 285.94 17.7398C279.94 17.7398 274.88 22.6998 274.9 28.9398C274.9 35.0798 279.98 39.9998 285.98 39.9798C289.12 39.9798 292 38.5998 294.02 36.3998L294.72 38.9798H301.1L293.82 12.3198ZM292.18 29.6998C291.8 32.3398 289.4 34.2798 286.76 34.2798C283.46 34.2798 280.96 31.9598 280.96 28.9598C280.96 25.7598 283.42 23.3798 286.74 23.3798C288.42 23.3798 290 24.1798 291.02 25.4598C291.76 26.3998 292.24 27.5998 292.24 28.9398C292.24 29.1998 292.24 29.4598 292.18 29.6998Z"
        fill="currentColor"
      />
    </svg>
  );
}
